
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newyork-seminar",
      function () {
        return require("private-next-pages/newyork-seminar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newyork-seminar"])
      });
    }
  